<template>
  <div>
    <FormStepInputs
      :step="{
        stepName: name,
        formInputs: content,
      }"
    >
      <template #title>
        <div class="flex gap-y-1">
          <PanelTitle v-bind="getFormInput(props.content, 'title')"></PanelTitle>
        </div>
      </template>
    </FormStepInputs>
  </div>
</template>
<script setup lang="ts">
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import { getFormInput } from '@/utils/form-input-helper';

const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();
</script>
